import { Area, AreaChart, CartesianGrid, ResponsiveContainer } from "recharts";

import { RoleplayRank } from "@/graphql";

interface EmptyStateDataPoint {
  score: number;
  date: string;
  rank: RoleplayRank;
  scenarioSlug: string;
  sessionUuid: string;
}

interface EmptyStateChartProps {
  className?: string;
}

// Custom dot component for empty state
const EmptyStateDot = (props: {
  cx?: number;
  cy?: number;
  payload?: EmptyStateDataPoint;
}) => {
  const { cx, cy } = props;

  if (!cx || !cy) return null;

  return (
    <circle
      cx={cx}
      cy={cy}
      r={6}
      fill="#FFFFFF"
      stroke="#CED5DE"
      strokeWidth={2}
    />
  );
};

export function EmptyStateChart({ className }: EmptyStateChartProps) {
  // Mock data points that match the Figma design positions
  const mockData: EmptyStateDataPoint[] = [
    {
      score: 25,
      date: "Point 1",
      rank: RoleplayRank.Unranked,
      scenarioSlug: "mock-scenario",
      sessionUuid: "mock-session-1",
    },
    {
      score: 35,
      date: "Point 2",
      rank: RoleplayRank.Unranked,
      scenarioSlug: "mock-scenario",
      sessionUuid: "mock-session-2",
    },
    {
      score: 65,
      date: "Point 3",
      rank: RoleplayRank.Unranked,
      scenarioSlug: "mock-scenario",
      sessionUuid: "mock-session-3",
    },
    {
      score: 85,
      date: "Point 4",
      rank: RoleplayRank.Unranked,
      scenarioSlug: "mock-scenario",
      sessionUuid: "mock-session-4",
    },
    {
      score: 95,
      date: "Point 5",
      rank: RoleplayRank.Unranked,
      scenarioSlug: "mock-scenario",
      sessionUuid: "mock-session-5",
    },
  ];

  return (
    <div className={`w-full h-48 rounded-[14px] bg-white  ${className}`}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={mockData}
          margin={{ top: 10, right: 10, left: 10, bottom: 10 }}
        >
          {/* Grid lines */}
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#F5F6F8"
            horizontal={true}
            vertical={false}
          />

          {/* Dashed line connecting the dots */}
          <Area
            type="monotone"
            dataKey="score"
            stroke="#CED5DE"
            strokeWidth={2}
            strokeDasharray="8 8"
            fill="none"
            dot={<EmptyStateDot />}
            activeDot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
